/* eslint-disable */
export default {
  activeCall: 'Appel en cours',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
